import React from "react";
import styled from "styled-components";
import { OwcIcon, OwcTypography } from "@one/react";

const ForbiddenAccessStyled = styled.div`
  font-family: Imago, sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(80vh - 96px);
  transform: translateY(-40px);

  color: var(--one-color-background-brand-1);
  & > .title {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const ForbiddenAccess = ({ title = "Access permission", text = "You do not have permisson to see this view." }) => {
  return (
    <ForbiddenAccessStyled data-testid="forbidden-access">
      <div className="title">
        <OwcIcon className="one-icons-outlined" name="lock" style={{ fontSize: 46 }} />
        <OwcTypography variant="title3">{title}</OwcTypography>
      </div>
      <OwcTypography variant="title5">{text}</OwcTypography>
    </ForbiddenAccessStyled>
  );
};

export default ForbiddenAccess;
